/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `Geotiff.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { Geotiff } from "./Geotiff";

import { Project } from "./Project";

export type status = "error" | "importing" | "complete";

export const statusValues = { error: 0, importing: 1, complete: 2 };

export abstract class GeotiffModel {
    id: number;
    createdAt: Dayjs;
    errorMessage: string | null;
    geotiffId: string | null;
    geotiffName: string | null;
    projectId: number | null;
    status: status;
    updatedAt: Dayjs;
    project: Project | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        errorMessage: string | null,
        geotiffId: string | null,
        geotiffName: string | null,
        projectId: number | null,
        status: status,
        updatedAt: Dayjs,
        project: Project | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.errorMessage = errorMessage;
        this.geotiffId = geotiffId;
        this.geotiffName = geotiffName;
        this.projectId = projectId;
        this.status = status;
        this.updatedAt = updatedAt;
        this.project = project;
    }
    /* eslint-enable max-statements */

    /** Rails `alias_attribute :name, :geotiff_name` */
    get name(): string | null {
        return this.geotiffName;
    }

    set name(value: string | null) {
        this.geotiffName = value;
    }

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): Geotiff {
        const newObject = new Geotiff(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["error_message"],
            json["geotiff_id"],
            json["geotiff_name"],
            json["project_id"],
            json["status"],
            dayjs(json["updated_at"]).tz(timezone),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            error_message: this.errorMessage,
            geotiff_id: this.geotiffId,
            geotiff_name: this.geotiffName,
            project_id: this.projectId,
            status: this.status,
            updated_at: this.updatedAt,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): Geotiff {
        const clone = Object.create(this) as Geotiff;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
